import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  subtext?: string;
  className?: string;
}
export function CtaButton({
  children,
  subtext,
  className = '',
  ...props
}: CtaButtonProps) {
  return <div className="flex flex-col items-center w-full my-8" data-id="element-2">
      <button className={`
          w-full md:w-auto md:min-w-[320px] 
          bg-[#8B1538] hover:bg-[#7F1D1D] active:bg-[#6B1729] 
          text-white font-bold text-xl py-4 px-8 rounded-lg 
          shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 
          flex items-center justify-center gap-2
          ${className}
        `} {...props} data-id="element-3">
        <span data-id="element-4">{children}</span>
        <ArrowRight className="w-6 h-6" data-id="element-5" />
      </button>
      {subtext && <p className="mt-3 text-sm text-gray-500 font-medium flex items-center gap-1" data-id="element-6">
          <span className="w-2 h-2 bg-[#F59E0B] rounded-full animate-pulse" data-id="element-7" />
          {subtext}
        </p>}
    </div>;
}